import { FETCH_PRODUCT, FETCH_PRODUCT_FAIL, FETCH_PRODUCTS, FETCH_PRODUCTS_FAIL, SET_PRODUCT_REDIRECT } from './types';
import { SLACK_WEBHOOKS } from '../config';
import axios from 'axios';
import { history } from '../components/app';
import { SlackWebhook } from './utils';

/*
//Fetch product via Contentful
import ContentfulHelper from '../helpers/contentfulhelper';

//Fetch product via contentful
export function FetchProduct(tourId){
  return (dispatch) => {
    ContentfulHelper.fetchEntriesType('product', 'fields.tourId', tourId)
    .then((data) => {
      dispatch({type:FETCH_PRODUCT, payload:data})
    })
    .catch((err) => {
      dispatch({type:FETCH_PRODUCT_FAIL})
    });
  }
}
*/


/**
 * Fetch single product via Busabout API
 *
 * @param {string} tourID - product tour id.
 * @param {string} currency - currency (GBP, AUD, USD, CAD).
 * @param {number} content - display product content. Use 0 to display none.
 * @param {number} productMap - display map content. Use 0 to display none.
 */
export function FetchProduct(tourID, currency, content, productMap){

  const hasContent = (content !== "") ? `&content=${content}` : "";
  const hasMap = (productMap !== "") ? `&map=${productMap}` : "";
  const productURL = `${process.env.REACT_APP_PRODUCTS_API}${tourID}?currency=${currency}${hasContent}${hasMap}&api_token=${process.env.REACT_APP_API_TOKEN}`

  return (dispatch) => {
    dispatch({type:SET_PRODUCT_REDIRECT,  payload:true})
    axios.get(productURL, {withCredentials: true})
    .then((data) => {
      if(data.data.errors){
        history.push('/');
      }else{
        dispatch({type:SET_PRODUCT_REDIRECT,  payload:false})
        dispatch({type:FETCH_PRODUCT, payload:data})
      }
    })
    .catch((err)=>{
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! PRODUCT API - ' + productURL + " " + err}));
      dispatch({type:FETCH_PRODUCT_FAIL});
      console.error(err);
      history.push('/');
    })
  }
}

/**
 * Fetch all products via Busabout API
 *
 * @param {string} currency - currency (GBP, AUD, USD, CAD).
 * @param {number} content - display product content. Use 0 to display none.
 * @param {array} toursID - array of tours id to show
 */
 export function FetchProducts(currency, toursID = []){

   const hasTours = (toursID !== []) ? `&tour_ids=${toursID}` : "";
   const productURL = `${process.env.REACT_APP_PRODUCTS_API}?currency=${currency}&api_token=${process.env.REACT_APP_API_TOKEN}${hasTours}`;

   return (dispatch) => {
     axios.get(productURL, {withCredentials: true})
     .then((data) => {
       dispatch({type:FETCH_PRODUCTS, payload:data})
     })
     .catch((err)=>{
       dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! PRODUCT API - ' + productURL + " " + err}));
       dispatch({type:FETCH_PRODUCTS_FAIL});
       console.error(err);
       history.push('/500');
     })
   }
 }


// WEBPACK FOOTER //
// ./src/actions/product.js